module.exports = __webpack_public_path__ + "img/ganxi01.9d5c0223.png";